import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
const ConfiguratorMain = ({
  className,
  currentStepName,
  children,
  ...rest
}) => {
  const mainRef = React.createRef();
  const isPhone = MediaQuery.useIsPhone();
  React.useLayoutEffect(() => {
    if (!isPhone) {
      return;
    }
    mainRef?.current?.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [currentStepName]);
  return /* @__PURE__ */ React.createElement("div", { ref: mainRef, "data-t": rest["data-t"], className }, children);
};
export {
  ConfiguratorMain
};
//# sourceMappingURL=ConfiguratorMain.js.map
